module.exports = __webpack_public_path__ + "img/save.09d2d272.png";